var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picture-preview"},[_c('div',{ref:"sources",staticClass:"preview-sources"},_vm._l((_vm.images),function(image){return _c('img',{key:image,attrs:{"src":image,"alt":""}})}),0),_c('div',{staticClass:"preview-trigger",on:{"click":_vm.show}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }